import React from 'react'

export default function ColoredText({ children }) {

    return(       
        <span style={{color:'#316fea'}}>
            {children}
        </span>
    )
}